﻿import { FIQAssist } from "../../app";
import { Memoize } from "@fiqas/utils";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { FiqassistApiServiceBase } from "./fiqassistApiServiceBase";
import { StartResult } from "../../models/home";
import { FiqassistApiURL, FiqassistVersion } from "../../constants";
import { AuthenticationService } from "../authenticationService";
import { FqsService } from "../fqsService";
import { StartVersion } from "../../models/version";
import { LogService } from "../logService";
import { User } from "../../models/user";
import { AuthorizationService } from "../authorizationService";

const ApiNotAvailible: StartVersion = { apiVersion: "Not availible", domainVersion: "Not availible", version: "Not availible" };

@Injectable({
    module: FIQAssist,
    selector: HomeService.selector
})
export class HomeService extends FiqassistApiServiceBase {
    public static selector = "HomeService"
    public static ApiNotAvailible: StartVersion = ApiNotAvailible;
    public fiqassistApiVersion: StartVersion = HomeService.ApiNotAvailible;

    constructor(
        @Inject('$q') $q: angular.IQService,
        @Inject('$http') $http: angular.IHttpService,
        @Inject() authenticationService: AuthenticationService,
        @Inject() authorizationService: AuthorizationService,
        @Inject('FiqassistApiURL') private FiqassistApiURL: FiqassistApiURL,
        @Inject('FiqassistVersion') public fiqassistClientVersion: FiqassistVersion,
        @Inject() private logService: LogService,
    ) {
        super($q, $http, authenticationService, authorizationService);
        authenticationService.addLoginHandler(() => this.resetMemoizedProperties());
        authenticationService.addLogoutHandler(() => this.resetMemoizedProperties());
        authorizationService.onRoleChanged(() => this.resetMemoizedProperties());
        this.recieveAPIVersion((apiVersion: StartVersion) => this.fiqassistApiVersion = apiVersion);
    }

    public recieveAPIVersion(action: (apiVersion: StartVersion) => void) {
        this.performRequest<void, StartVersion>("GET", `${this.FiqassistApiURL}/Home/Version`)
            .then(
                succes => { this.fiqassistApiVersion = succes; },
                failure => { this.fiqassistApiVersion = HomeService.ApiNotAvailible }
            ).finally(
                () => { if (action) action(this.fiqassistApiVersion); }
            );
    }

    private resetMemoizedProperties() {
        this.StartResult = null;
    }

    @Memoize()
    public get StartResult() {
        if (this.authorizationService && this.authenticationService && this.authenticationService.username) {
            var p = this.start(this.authenticationService.username);
            p.catch(() => this.StartResult = null);
            return <any>p;
        }
        return null;
    }
    private async start(user: string) {
         await this.authorizationService.roleLoaded;
        return this.performRequest<void, StartResult>("GET", `${this.FiqassistApiURL}/Home/${user}`);
    }

    public set StartResult(value: angular.IPromise<StartResult>) { }
}
